import { NAME, LOADING_NAME, ERROR_NAME } from './constants';

export const isLoading = (state, actionType) => state[NAME][LOADING_NAME][actionType];
export const isLoadingWithRequestId = (state, actionType, requestId) => isLoading(state, `${actionType}/${requestId}`);
export const getError = (state, actionType) => state[NAME][ERROR_NAME][actionType];

export const getSecondParam = (firstParam, secondParam) => secondParam;
export const getThirdParam = (firstParam, secondParam, thirdParam) => thirdParam;